import { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react';
import { isDate, parseISO } from 'date-fns';

import DatePicker from '../forms/Datepicker';

const getInitialValue = (value, nullable) => {
    if (!value || value === 'Invalid Date' || !isDate(parseISO(value))) {
        return nullable ? null : new Date();
    }

    return new Date(value);
};

const DataGridCalendar = forwardRef(({ nullable = false, column, ...props }, ref) => {
    const initialValue = getInitialValue(props.value, nullable);
    const [date, setDate] = useState(initialValue);
    const editorParams = column.getColDef()?.cellEditorParams;

    const dateRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            dateRef.current.setFocus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (typeof date === 'string') {
                    return date;
                }

                if (!date) {
                    return nullable ? null : 'Invalid Date';
                }

                return date;
            },
        };
    });

    return (
        <DatePicker
            ref={dateRef}
            value={date}
            onChange={(date) => setDate(date)}
            portalId="root-portal"
            dateFormat={editorParams.dateFormat}
            onCalendarClose={() => {
                if (initialValue !== date) {
                    setTimeout(() => {
                        props.api.stopEditing();
                        props.api.tabToNextCell();
                        props.api.tabToPreviousCell();
                    });
                }
            }}
            closeOnScroll={(event) => event.type === 'scroll'}
            isClearable={nullable}
        />
    );
});

export default DataGridCalendar;
